<template>
    <div class="accountcreditcard">
        <PageTitle
            icon="fa fa-clone"
            main="Registro"
            sub="Cartão de Crédito "
        />
        <b-form
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'"
        >
            <input
                id="accountcreditcard-id"
                type="hidden"
                v-model="accountcreditcard.id"
            />
            <b-row>
                <b-col md="5" sm="12">
                    <b-form-group
                        label="Nome:"
                        label-for="accountcreditcard-name"
                    >
                        <b-form-input
                            id="accountcreditcard-name"
                            type="text"
                            ref="searchFocus"
                            v-model="accountcreditcard.name_account_credit_card"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Nome do Cartão de Crédito..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Empresa:"
                        label-for="accountcreditcard-company_id"
                    >
                        <b-form-select
                            id="accountcreditcard-company_id"
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="companys"
                            v-model="accountcreditcard.credit_card_company_id"
                        />
                    </b-form-group>
                </b-col>
                <!--b-col md="2" sm="12">
                    <b-form-group
                        label="Taxa de Antecipação:"
                        label-for="accountcreditcard-tax_anticipation"
                    >
                        <b-form-input
                            id="accountcreditcard-tax_anticipation"
                            v-model="accountcreditcard.tax_anticipation"
                            type="number"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                    </b-form-group>
                </b-col!-->
                <b-col md="2" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="accountcreditcard.blocked"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="accountcreditcard-blocked"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="accountcreditcard-blocked"
                            >
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <!--b-col md="4" sm="12">
                    <b-form-group
                        label="Bandeira:"
                        label-for="accountcreditcard-credit_card_flag_id"
                    >
                        <b-form-select
                            id="accountcreditcard-credit_card_flag_id"
                            @input="
                                loadEntityBank(
                                    accountcreditcard.credit_card_company_id
                                )
                            "
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="creditcardflags"
                            v-model="accountcreditcard.credit_card_flag_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Banco:"
                        label-for="accountcreditcard-entity_id_bank"
                    >
                        <b-form-select
                            id="accountcreditcard-entity_id_bank"
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="settlementforms"
                            v-model="accountcreditcard.entity_id_bank"
                        />
                    </b-form-group>
                </b-col!-->
            </b-row>
            <b-row>
                <b-col md="1" sm="2">
                    <b-form-group label="ID" label-for="entity-id">
                        <b-form-input
                            id="entity-id"
                            type="text"
                            v-model="accountcreditcard.entity_id_credit_card"
                            @input="setEntity()"
                            @change="setEntity"
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Código..."
                        />
                    </b-form-group>
                </b-col>
                <b-link
                    :disabled="
                        mode === 'remove' ||
                            mode === 'read' ||
                            mode === 'insert'
                    "
                    v-b-modal.modalEntity
                    @click="showEntity = true"
                    class="fa fa-search mt-4"
                ></b-link>
                <b-col md="6" sm="8">
                    <b-form-group label="Nome:" label-for="entity-name_entity">
                        <b-form-input
                            id="entity-name_entity"
                            type="text"
                            v-model="entity.name_entity"
                            size="sm"
                            :readonly="true"
                            placeholder="Nome..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="2">
                    <b-form-group label="CPF/CNPJ:" label-for="entity-cnpj_cpf">
                        <b-form-input
                            id="entity-cnpj_cpf"
                            type="text"
                            v-model="entity.cnpj_cpf"
                            size="sm"
                            :readonly="true"
                            placeholder=""
                        />
                    </b-form-group>
                </b-col>
                <b-link
                    v-b-modal.modalRegisterEntity
                    class="fa fa-plus mt-4"
                ></b-link>
            </b-row>
        </b-form>
        <hr v-show="mode === 'save'" />
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    variant="dark"
                    title="Adicionar"
                    class="mt-2  mb-2 fa fa-plus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    @click="alterModo"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    title="Salvar"
                    class="mt-2 mb-2 ml-2 fa fa-save"
                    v-if="mode === 'save'"
                    @click="save"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    title="Excluir"
                    class="mt-2 mb-2 ml-2 fa fa-trash"
                    v-if="mode === 'remove'"
                    @click="remove"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="dark"
                    title="Voltar"
                    class="mt-2 mb-2 ml-2 fa fa-reply"
                    v-if="
                        mode === 'remove' || mode === 'save' || mode === 'read'
                    "
                    @click="reset"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 mb-2 ml-2 fa"
                    :class="icon"
                    @click="
                        ;[
                            loadAccountCreditCards(),
                            toggleBusy(),
                            (showTable = !showTable)
                        ]
                    "
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <br />
        <div class="col-sm-4">
            <div class="form-group">
                <input
                    type="text"
                    size="sm"
                    icon="search"
                    v-model="search"
                    ref="searchFocus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    placeholder="Informe a descrição"
                    class="form-control"
                />
            </div>
        </div>
        <b-row>
            <b-col md="5" sm="12">
                <transition name="slide" type="animation" appear>
                    <b-table
                        :busy="isBusy"
                        class="table-responsive"
                        v-show="showTable"
                        hover
                        key="slide"
                        head-variant="light"
                        :items="filteredList"
                        :fields="fields"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center text-info my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Carregando...</strong>
                            </div>
                        </template>
                        <template v-slot:cell(actions)="data">
                            <b-button
                                title="Detalhe do registro"
                                size="sm"
                                variant="light"
                                @click="
                                    loadAccountCreditCard(data.item, 'read')
                                "
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-drivers-license-o"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="loadAccountCreditCard(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="
                                    loadAccountCreditCard(data.item, 'remove')
                                "
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-trash"></i>
                            </b-button>
                            <b-button
                                v-b-modal.modalRate
                                title="Adicionar Taxa"
                                size="sm"
                                variant="light"
                                @click="actionNewRate(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-plus"></i>
                            </b-button>
                            <b-button
                                title="Listar Taxa(s)"
                                size="sm"
                                variant="light"
                                @click="setRate(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-tasks"></i>
                            </b-button>
                        </template>
                    </b-table>
                </transition>
                <transition name="slide" type="animation" appear>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        size="sm"
                        aria-controls="my-table"
                    ></b-pagination>
                </transition>
            </b-col>
            <b-col md="3" sm="12">
                <transition name="slide" type="animation" appear>
                    <b-table
                        class="table-responsive"
                        v-show="showTableRate"
                        hover
                        key="slide"
                        head-variant="light"
                        :items="accountcreditcardsrates"
                        :fields="fieldsRate"
                    >
                        <template v-slot:cell(actions)="data">
                            <b-button
                                v-b-modal.modalRate
                                title="Editar registro"
                                size="sm"
                                variant="light"
                                @click="loadAccountCreditCardsRate(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="modeRate = 'remove'"
                                class="mr-2 mt-2"
                                v-if="modeRate === 'insert'"
                            >
                                <i class="fa fa-trash"></i>
                            </b-button>
                            <b-button
                                v-b-modal.modalCondition
                                title="Adicionar Condição de Recebimento"
                                size="sm"
                                variant="light"
                                @click="actionNewRateCondition(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-plus"></i>
                            </b-button>
                            <b-button
                                title="Listar Condição de Recebimento"
                                size="sm"
                                variant="light"
                                @click="setCondition(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-tasks"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="
                                    ;[
                                        loadAccountCreditCardsRate(data.item),
                                        removeRate(data.item),
                                        (modeRate = 'insert')
                                    ]
                                "
                                class="mr-2 mt-2"
                                v-if="modeRate === 'remove'"
                            >
                                <i class="fa fa-check"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="modeRate = 'insert'"
                                class="mr-2 mt-2"
                                v-if="modeRate === 'remove'"
                            >
                                <i class="fa fa-times"></i>
                            </b-button>
                            <span class="mr-2 mt-2" v-if="modeRate === 'remove'"
                                >Deseja Excluir o registro?</span
                            >
                        </template>
                    </b-table>
                </transition>
            </b-col>

            <b-col md="4" sm="12">
                <transition name="slide" type="animation" appear>
                    <b-table
                        class="table-responsive"
                        v-show="showTableCondition"
                        hover
                        key="slide"
                        head-variant="light"
                        :items="accountcreditcardsratesconditionreceipts"
                        :fields="fieldsCondition"
                    >
                        <template v-slot:cell(actions)="data">
                            <b-button
                                v-b-modal.modalCondition
                                title="Editar registro"
                                size="sm"
                                variant="light"
                                @click="
                                    loadAccountCreditCardsRateCondition(
                                        data.item
                                    )
                                "
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="modeCondition = 'remove'"
                                class="mr-2 mt-2 fa fa-trash"
                                v-if="modeCondition === 'insert'"
                            >
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="
                                    ;[
                                        loadAccountCreditCardsRateCondition(
                                            data.item
                                        ),
                                        removeCondition(data.item),
                                        (modeCondition = 'insert')
                                    ]
                                "
                                class="mr-2 mt-2 fa fa-check"
                                v-if="modeCondition === 'remove'"
                            >
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="modeCondition = 'insert'"
                                class="mr-2 mt-2"
                                v-if="modeCondition === 'remove'"
                            >
                                <i class="fa fa-times"></i>
                            </b-button>
                            <span
                                class="mr-2 mt-2"
                                v-if="modeCondition === 'remove'"
                                >Deseja Excluir o registro?</span
                            >
                        </template>
                    </b-table>
                </transition>
            </b-col>
        </b-row>

        <b-modal
            id="modalRate"
            ref="modal"
            title-tag="h6"
            title="Taxa"
            size="lq"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveRate"
        >
            <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Descrição:"
                            label-for="accountcreditcardsrate-rate_name"
                        >
                            <b-form-input
                                id="accountcreditcardsrate-rate_name"
                                v-model="accountcreditcardsrate.rate_name"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Retenção:"
                            label-for="accountcreditcardsrate-retention_card_id"
                        >
                            <b-form-select
                                id="accountcreditcardsrate-retention_card_id"
                                size="sm"
                                :options="retentions"
                                v-model="
                                    accountcreditcardsrate.retention_card_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <!--b-col md="3" sm="12">
                        <b-form-group
                            label="Taxa:"
                            label-for="accountcreditcardsrate-rate_value"
                        >
                            <b-form-input
                                id="accountcreditcardsrate-rate_value"
                                v-model="accountcreditcardsrate.rate_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col!-->

                    <b-col md="5" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="accountcreditcardsrate.blocked"
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox"
                                    id="accountcreditcardsrate-blocked"
                                    :readonly="
                                        mode === 'remove' ||
                                            mode === 'read' ||
                                            mode === 'insert'
                                    "
                                />
                                <label
                                    class="form-check-label"
                                    for="accountcreditcardsrate-blocked"
                                >
                                    Bloqueado?
                                </label>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalCondition"
            ref="modal"
            title-tag="h6"
            title="Condição de Recebimento"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveCondition"
        >
            <b-form>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Nº Parcela(s):"
                            label-for="accountcreditcardsratesconditionreceipt-number_portion"
                        >
                            <b-form-input
                                id="accountcreditcardsratesconditionreceipt-number_portion"
                                v-model="
                                    accountcreditcardsratesconditionreceipt.number_portion
                                "
                                type="number"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="9" sm="12">
                        <b-form-group
                            label="Condição de Recebimento:"
                            label-for="accountcreditcardsratesconditionreceipt-condition_payment_receipt_id"
                        >
                            <b-form-select
                                id="accountcreditcardsratesconditionreceipt-condition_payment_receipt_id"
                                size="sm"
                                :options="conditionpaymentreceipts"
                                v-model="
                                    accountcreditcardsratesconditionreceipt.condition_payment_receipt_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Taxa:"
                            label-for="accountcreditcardsratesconditionreceipt-rate_tax_value"
                        >
                            <b-form-input
                                id="accountcreditcardsratesconditionreceipt-rate_tax_value"
                                v-model="
                                    accountcreditcardsratesconditionreceipt.rate_tax_value
                                "
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Taxa Antecipação:"
                            label-for="accountcreditcardsratesconditionreceipt-rate_tax_anticipation_value"
                        >
                            <b-form-input
                                id="accountcreditcardsratesconditionreceipt-rate_tax_anticipation_value"
                                v-model="
                                    accountcreditcardsratesconditionreceipt.rate_tax_anticipation_value
                                "
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Retenção Antecipação:"
                            label-for="accountcreditcardsratesconditionreceipt-retention_anticipation_card_id"
                        >
                            <b-form-select
                                id="accountcreditcardsratesconditionreceipt-retention_anticipation_card_id"
                                size="sm"
                                :options="retentions"
                                v-model="
                                    accountcreditcardsratesconditionreceipt.retention_anticipation_card_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="
                                        accountcreditcardsratesconditionreceipt.anticipation_settlement
                                    "
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox"
                                    id="accountcreditcardsratesconditionreceipt-anticipation_settlement"
                                />
                                <label
                                    class="form-check-label"
                                    for="accountcreditcardsratesconditionreceipt-anticipation_settlement"
                                >
                                    Gerar liquidação?
                                </label>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="6" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="
                                        accountcreditcardsratesconditionreceipt.blocked
                                    "
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox"
                                    id="accountcreditcardsratesconditionreceipt-blocked"
                                />
                                <label
                                    class="form-check-label"
                                    for="accountcreditcardsratesconditionreceipt-blocked"
                                >
                                    Bloqueado?
                                </label>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Conta Banco/Caixa:"
                            label-for="accountcreditcardsratesconditionreceipt-entity_settlement_id"
                        >
                            <b-form-select
                                id="accountcreditcardsratesconditionreceipt-entity_settlement_id"
                                size="sm"
                                :options="entitysettlements"
                                v-model="
                                    accountcreditcardsratesconditionreceipt.entity_settlement_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalEntity"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor/Banco/Caixa/Aplicação Financeira"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="setSearchEntity"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entity.name_entity = $event"
                @setEntityCnpjCpf="entity.cnpj_cpf = $event"
            />
        </b-modal>
        <b-modal
            id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntityModal />
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
var moment = require('moment')

export default {
    name: 'AccountCreditCard',
    components: { PageTitle, EntityModal, EntitySearchModal },
    data: function() {
        return {
            mode: 'insert',
            modeRate: 'insert',
            modeCondition: 'insert',
            search: '',
            searchEntity: '',
            entity_id: null,
            entitysshearch: [],
            accountcreditcard: {},
            accountcreditcards: [],
            accountcreditcardsrate: {},
            accountcreditcardsrates: [],
            accountcreditcardsratesconditionreceipt: {},
            accountcreditcardsratesconditionreceipts: [],
            companys: [],
            typecosts: [],
            typeentitys: [],
            operationsreceipts: [],
            operationsrpurchases: [],
            creditcardflags: [],
            settlementforms: [],
            entitysettlements: [],
            retentions: [],
            conditionpaymentreceipts: [],
            entity: {},
            entitys: [],
            showTable: false,
            showTableRate: false,
            showTableCondition: false,
            showEntity: false,
            isBusy: false,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            perPage: 5,
            currentPage: 1,
            fields: [
                {
                    key: 'name_account_credit_card',
                    label: 'Nome',
                    sortable: true,
                    variant: 'secondary'
                },
                { key: 'name_company', label: 'Empresa', sortable: false },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            fieldsRate: [
                {
                    key: 'rate_name',
                    label: 'Descrição',
                    sortable: true,
                    variant: 'secondary'
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            fieldsCondition: [
                {
                    key: 'number_portion',
                    label: 'Nº Parc.',
                    sortable: true,
                    variant: 'secondary'
                },
                { key: 'rate_tax_value', label: '(%)Taxa', sortable: false },
                {
                    key: 'rate_tax_anticipation_value',
                    label: '(%)Antecipação',
                    sortable: false
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        filteredList() {
            return this.accountcreditcards.filter(accountcreditcard => {
                return accountcreditcard.name_account_credit_card
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
            })
        },
        filteredListEntity() {
            return this.entitysshearch.filter(entity => {
                return (
                    entity.name_entity
                        .toLowerCase()
                        .includes(this.searchEntity.toLowerCase()) ||
                    entity.cnpj_cpf
                        .toLowerCase()
                        .includes(this.searchEntity.toLowerCase())
                )
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.accountcreditcard.length
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD')
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        async loadAccountCreditCards() {
            const url = `${baseApiUrl}/accountcreditcards`
            await axios.get(url).then(res => {
                this.accountcreditcards = res.data
            })
        },
        async loadAccountCreditCardsRates() {
            const url = `${baseApiUrl}/accountcreditcardsratescreditcard/${this.accountcreditcard.id}`
            await axios.get(url).then(res => {
                this.accountcreditcardsrates = res.data
            })
        },
        async loadAccountCreditCardsRateConditions() {
            const url = `${baseApiUrl}/accountcreditcardsratesconditionreceipts/${this.accountcreditcardsrate.id}`
            await axios.get(url).then(res => {
                this.accountcreditcardsratesconditionreceipts = res.data
            })
        },
        reset() {
            this.mode = 'insert'
            this.loadAccountCreditCards()
        },
        alterModo() {
            this.mode = 'save'
            this.accountcreditcard = {}
            this.accountcreditcardsrate = {}
            this.accountcreditcardsratesconditionreceipt = {}
            this.showTableRate = false
            this.showTableCondition = false
            this.$refs.searchFocus.focus()
        },
        async save() {
            this.accountcreditcard.user_id = this.user.id
            const method = this.accountcreditcard.id ? 'put' : 'post'
            const id = this.accountcreditcard.id
                ? `/${this.accountcreditcard.id}`
                : ''
            await axios[method](
                `${baseApiUrl}/accountcreditcards${id}`,
                this.accountcreditcard
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async remove() {
            const id = this.accountcreditcard.id
            await axios
                .delete(`${baseApiUrl}/accountcreditcards/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadAccountCreditCard(accountcreditcard, mode = 'save') {
            this.mode = mode
            this.entity = {}
            this.accountcreditcard = { ...accountcreditcard }
            this.setEntity()
            this.$refs.searchFocus.focus()
        },
        loadCompanys() {
            const url = `${baseApiUrl}/companys`
            axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
        async loadEntityBank(company) {
            const url = `${baseApiUrl}/entitysettement/${company}`
            await axios.get(url).then(res => {
                this.settlementforms = res.data.map(settlementform => {
                    return {
                        value: settlementform.id,
                        text: settlementform.name_entity
                    }
                })
            })
        },
        async loadCreditCardFlags() {
            const url = `${baseApiUrl}/creditcardflag`
            await axios.get(url).then(res => {
                this.creditcardflags = res.data.map(creditcardflag => {
                    return {
                        value: creditcardflag.id,
                        text: creditcardflag.name_credit_card_flag
                    }
                })
            })
        },
        loadAccountCreditCardsRate(accountcreditcardsrate) {
            this.accountcreditcardsrate = { ...accountcreditcardsrate }
        },
        loadAccountCreditCardsRateCondition(accountcreditcardsratecondition) {
            this.accountcreditcardsratesconditionreceipt = {
                ...accountcreditcardsratecondition
            }
        },
        actionNewRate(accountcreditcard) {
            this.accountcreditcard = { ...accountcreditcard }
            this.accountcreditcardsrate = {}
            this.loadAccountCreditCardsRates()
            this.showTableRate = true
        },
        actionNewRateCondition(accountcreditcardsrate) {
            this.accountcreditcardsrate = { ...accountcreditcardsrate }
            this.accountcreditcardsratesconditionreceipt = {}
            this.loadAccountCreditCardsRateConditions()
            this.showTableCondition = true
        },
        async saveRate() {
            if (this.accountcreditcardsrate.id) {
                this.accountcreditcardsrate.user_update_id = this.user.id
                this.accountcreditcardsrate.update_date = this.formatDate(
                    Date()
                )
            } else {
                this.accountcreditcardsrate.user_id = this.user.id
            }

            const method = this.accountcreditcardsrate.id ? 'put' : 'post'
            const id = this.accountcreditcardsrate.id
                ? `/${this.accountcreditcardsrate.id}`
                : ''

            this.accountcreditcardsrate.account_credit_card_id = this.accountcreditcard.id
            await axios[method](
                `${baseApiUrl}/accountcreditcardsrates${id}`,
                this.accountcreditcardsrate
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadAccountCreditCardsRates()
                })
                .catch(showError)
        },
        async saveCondition() {
            if (this.accountcreditcardsratesconditionreceipt.id) {
                this.accountcreditcardsratesconditionreceipt.user_update_id = this.user.id
                this.accountcreditcardsratesconditionreceipt.update_date = this.formatDate(
                    Date()
                )
            } else {
                this.accountcreditcardsratesconditionreceipt.user_id = this.user.id
            }

            const method = this.accountcreditcardsratesconditionreceipt.id
                ? 'put'
                : 'post'
            const id = this.accountcreditcardsratesconditionreceipt.id
                ? `/${this.accountcreditcardsratesconditionreceipt.id}`
                : ''

            this.accountcreditcardsratesconditionreceipt.account_credit_card_rate_id = this.accountcreditcardsrate.id
            await axios[method](
                `${baseApiUrl}/accountcreditcardsratesconditionreceipts${id}`,
                this.accountcreditcardsratesconditionreceipt
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadAccountCreditCardsRateConditions()
                })
                .catch(showError)
        },
        async removeRate() {
            const id = this.accountcreditcardsrate.id
            await axios
                .delete(`${baseApiUrl}/accountcreditcardsrates/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadAccountCreditCardsRates()
                })
                .catch(showError)
        },
        async removeCondition() {
            const id = this.accountcreditcardsratesconditionreceipt.id
            await axios
                .delete(
                    `${baseApiUrl}/accountcreditcardsratesconditionreceipts/${id}`
                )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadAccountCreditCardsRateConditions()
                })
                .catch(showError)
        },
        loadTypeCost() {
            const url = `${baseApiUrl}/typecosts`
            axios.get(url).then(res => {
                this.typecosts = res.data.map(typecost => {
                    return { value: typecost.id, text: typecost.name_type_cost }
                })
            })
        },
        async loadOperationReceipt() {
            const url = `${baseApiUrl}/operationtsale`
            await axios.get(url).then(res => {
                this.operationsreceipts = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation
                    }
                })
            })
        },
        async loadOperationPurchase() {
            const url = `${baseApiUrl}/operationpurchase`
            await axios.get(url).then(res => {
                this.operationsrpurchases = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation
                    }
                })
            })
        },
        async loadConditionPaymentReceipt() {
            const url = `${baseApiUrl}/conditionpaymentreceipts`
            await axios.get(url).then(res => {
                this.conditionpaymentreceipts = res.data.map(
                    conditionpaymentreceipt => {
                        return {
                            value: conditionpaymentreceipt.id,
                            text:
                                conditionpaymentreceipt.name_condition_payment_receipt
                        }
                    }
                )
            })
        },
        async setEntity(entity) {
            if (!this.accountcreditcard.entity_id_credit_card) {
                this.accountcreditcard.entity_id_credit_card = entity.id
            }

            const url = `${baseApiUrl}/entitys/${this.accountcreditcard.entity_id_credit_card}`
            await axios(url).then(res => (this.entity = res.data))
        },
        async loadEntitys() {
            const url = `${baseApiUrl}/entitys`
            await axios.get(url).then(res => {
                this.entitysshearch = res.data
            })
        },
        setSearchEntity() {
            this.accountcreditcard = {
                ...this.accountcreditcard,
                entity_id_credit_card: this.entity_id
            }
        },
        setRate(accountcreditcard) {
            this.accountcreditcard = { ...accountcreditcard }
            this.loadAccountCreditCardsRates()
            this.showTableRate = true
        },
        setCondition(accountcreditcardsrate) {
            this.accountcreditcardsrate = { ...accountcreditcardsrate }
            this.loadAccountCreditCardsRateConditions()
            this.loadEntitySettlements()
            this.showTableCondition = true
        },
        loadRetention() {
            const url = `${baseApiUrl}/retentions/?operation_id=${2}`
            axios.get(url).then(res => {
                this.retentions = res.data.map(retention => {
                    return {
                        value: retention.id,
                        text: retention.name_retention
                    }
                })
            })
        },
        hideModal() {
            this.$bvModal.hide('modalEntity')
        },
        async loadEntitySettlements() {
            const url = `${baseApiUrl}/entitysettement/${this.accountcreditcard.credit_card_company_id}`
            await axios.get(url).then(res => {
                this.entitysettlements = res.data.map(entitysettlement => {
                    return {
                        value: entitysettlement.id,
                        text: `${entitysettlement.name_entity} - ${entitysettlement.cnpj_cpf}`
                    }
                })
            })
        }
    },
    mounted() {
        this.loadCompanys()
        this.loadCreditCardFlags()
        this.loadConditionPaymentReceipt()
        this.loadAccountCreditCards()
        this.showTable = true
        this.loadRetention()
    }
}
</script>

<style>
.accountcreditcard label {
    font-size: 0.75rem;
}

.accountcreditcard select {
    font-size: 0.75rem;
}
.accountcreditcard input {
    font-size: 0.75rem;
}
.accountcreditcard button {
    font-size: 0.75rem;
}

#modalRate {
    font-size: 0.75rem;
}

#modalRate input {
    font-size: 0.75rem;
}
#modalRate select {
    font-size: 0.75rem;
}

#modalRate button {
    font-size: 0.75rem;
}

#modalCondition {
    font-size: 0.75rem;
}

#modalCondition input {
    font-size: 0.75rem;
}

#modalCondition select {
    font-size: 0.75rem;
}

#modalCondition button {
    font-size: 0.75rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
